import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item"];

  connect() {
    this.itemTargets.forEach((item) => (item.draggable = "true"));
  }

  dragstart(event) {
    event.dataTransfer.setData(
      "application/drag-key",
      event.target.dataset.itemId,
    );
    event.dataTransfer.effectAllowed = "move";
    event.currentTarget.dataset.inFlight = true;
  }

  // Normally this might be handled by drop, but the one place we use this
  // doesn't persist anything to the server. It just rearranges the elements so
  // that when you click save, it submits the form with the elements correctly.
  // Other future forms may need something different, e.g. submitting data to an
  // API after the element is dropped. If that's the case, it might make sense
  // to rename this controller to something like "reorder" and make a new
  // controller for submitting after drop.
  dragover(event) {
    event.preventDefault();
    const sibling = event.target.closest("[data-draggable-target]");
    var data = event.dataTransfer.getData("application/drag-key");
    const dropTarget = event.currentTarget;
    const draggedItem = this.element.querySelector(`[data-item-id='${data}']`);
    const draggedPosition = this.comparePositions(draggedItem, dropTarget);
    if (draggedPosition == -1) {
      sibling.insertAdjacentElement("beforebegin", draggedItem);
    } else if (draggedPosition == 1) {
      sibling.insertAdjacentElement("afterend", draggedItem);
    }

    // If we're dealing with rails nested forms, the name attributes of form
    // inputs must get reindexed so they get sent to the controller in the right
    // order. If there are two indexes (doubly nested form) then this probably
    // won't work because it will change all indexes, not just the last one.
    for (let i = 0; i < this.itemTargets.length; i++) {
      this.itemTargets[i]
        .querySelectorAll(`[name*=${CSS.escape("_attributes][")}]`)
        .forEach(
          (input) => (input.name = input.name.replace(/\[\d+\]/, `[${i}]`)),
        );
    }
  }

  dragend(event) {
    delete event.currentTarget.dataset.inFlight;
  }

  drop(event) {
    // Prevent the default "release" animation
    event.preventDefault();
  }

  comparePositions(draggedItem, hoveredItem) {
    const positionComparison = hoveredItem.compareDocumentPosition(draggedItem);
    if (positionComparison & 4) {
      return -1;
    } else if (positionComparison & 2) {
      return 1;
    }
  }
}
